import React, { useEffect, useState } from 'react';
import Blocks from '@/src/cms/components/CMSPage/CorePage/Blocks';
import HeroContent from '@/src/cms/components/CMSPage/CorePage/HeroContent';
import DesignPage from '@/src/cms/models/DesignPage';
import ContactUsForm from '@/src/contactUs/components/ContactUsForm';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import request from '@/utils/axios';

const ContactUs = props => {
  const { messageData = {} } = props;
  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchDesignPage = async () => {
    const response = await request({
      url: `cms/designpage`,
      params: {
        alias: 'contactus',
      },
    });
    const { data } = response;
    setPageData(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchDesignPage();
  }, []);

  if (loading) {
    return null;
  }

  const page = new DesignPage({ ...pagedata, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="508" pageType="core" />
      <HeroContent
        heroData={{
          ...page,
        }}
      />
      {page.Blocks.map(b => (
        <Blocks key={b} blockData={page.entities.Blocks[b]} entities={page.entities} />
      ))}
      <Section bgColor="gray">
        <Container size="sm">
          <ContactUsForm />
        </Container>
      </Section>
      <WebLogImage path="/about/contact-us/form" pagedata={pagedata} />
    </Layout>
  );
};

export default ContactUs;
